import clsx from 'clsx';

import { useT } from '~/i18n/LocaleContext';

type Props = {
	address: string | null;
	connecting: boolean;
	hasProvider: boolean;
	onConnect: () => void;
	onDisconnect: () => void;
};

function shortAddr(addr: string): string {
	return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

export function BscConnectButton({
	address,
	connecting,
	hasProvider,
	onConnect,
	onDisconnect,
}: Props) {
	const t = useT();
	if (address) {
		return (
			<div className="flex items-center gap-2">
				<span className="rounded-lg border border-gray-45 bg-white px-3 py-2 font-mono text-bodySmall text-steel-darker">
					BSC {shortAddr(address)}
				</span>
				<button
					type="button"
					onClick={onDisconnect}
					className="rounded-lg border border-gray-45 px-3 py-2 text-bodySmall font-medium text-steel-dark hover:bg-gray-20"
				>
					{t('bridge.disconnect')}
				</button>
			</div>
		);
	}

	return (
		<button
			type="button"
			disabled={connecting || !hasProvider}
			onClick={onConnect}
			className={clsx(
				'rounded-lg p-3 text-bodySmall font-semibold',
				hasProvider
					? 'bg-[#F0B90B] text-[#0f0e0e] hover:brightness-95'
					: 'cursor-not-allowed bg-gray-40 text-steel',
			)}
			title={hasProvider ? t('bridge.connectMetaMask') : t('bridge.installEvm')}
		>
			{connecting ? t('common.connecting') : hasProvider ? t('bridge.connectBsc') : t('bridge.noEvm')}
		</button>
	);
}
